import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Collection, CollectionAccessGrant} from "../../../collection.model";
import {TranslatePipe} from "@ngx-translate/core";
import {MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {
    MatAutocomplete,
    MatAutocompleteSelectedEvent,
    MatAutocompleteTrigger,
    MatOption
} from "@angular/material/autocomplete";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {UserStub} from "../../../../user/user-stub";
import {UserService} from "../../../../user/user.service";
import {MatDivider} from "@angular/material/divider";
import {debounceTime, distinctUntilChanged, Subscription} from "rxjs";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatSelect} from "@angular/material/select";
import {CollectionService} from "../../../collection.service";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {SnackBarService} from "../../../../common/snack-bar-service";
import moment from "moment/moment";
import {MatTimepicker, MatTimepickerInput, MatTimepickerToggle} from "@angular/material/timepicker";

@Component({
    selector: 'app-collection-share-access',
    imports: [
        TranslatePipe,
        MatFormField,
        MatInput,
        MatAutocomplete,
        MatAutocompleteTrigger,
        MatLabel,
        MatOption,
        ReactiveFormsModule,
        MatDivider,
        MatIconButton,
        MatIcon,
        MatSelect,
        MatButton,
        MatDatepickerInput,
        MatDatepickerToggle,
        MatDatepicker,
        MatSuffix,
        MatTimepickerToggle,
        MatTimepicker,
        MatTimepickerInput
    ],
    templateUrl: './collection-share-access.component.html',
    styleUrl: './collection-share-access.component.scss'
})
export class CollectionShareAccessComponent {

    @Input({required: true}) collection!: Collection;
    @Output() collectionChange = new EventEmitter<Collection>();
    @Output() back = new EventEmitter<void>();

    userForm: FormGroup;
    userSuggestions: UserStub[] = [];
    searchSubscription: Subscription | undefined;
    selectedUsers: UserStub[] = [];

    permissionForm: FormGroup;

    validForm: FormGroup;

    error: string | null = null;

    constructor(
        private userService: UserService,
        private collectionService: CollectionService,
        private snackbarService: SnackBarService,
        private fb: FormBuilder
    ) {
        this.userForm = fb.group({
            search: ['', []],
            userId: ['', [Validators.required]],
        })
        this.permissionForm = fb.group({
            permission: ['download', [Validators.required]]
        });
        this.validForm = fb.group({
            validFrom: [null],
            validUntil: [null, []]
        });
    }

    ngOnInit() {
        this.searchSubscription = this.userForm.controls['search'].valueChanges
            .pipe(
                debounceTime(500),
                distinctUntilChanged()
            ).subscribe(searchTerm => {
                if (typeof searchTerm === 'string' && searchTerm.length >= 2) {
                    this.userService.search(searchTerm).subscribe({
                        next: users => {
                            this.userSuggestions = users;
                        }
                    });
                }
            })
    }

    displayUser(coll: UserStub) {
        return coll && coll.fullName ? coll.fullName : '';
    }

    selectUser($event: MatAutocompleteSelectedEvent) {
        const user: UserStub = $event.option.value;
        this.selectedUsers.push(user);
        this.userForm.patchValue({
            userId: '',
            search: ''
        })
    }

    removeUser(user: UserStub) {
        this.selectedUsers = this.selectedUsers.filter(u => u.id !== user.id);
    }

    doShare() {
        let validFrom: string | undefined = undefined
        if (this.validForm.value.validFrom) {
            validFrom = moment(this.validForm.value.validFrom).format('YYYY-MM-DDTHH:mm:ssZ');
        }
        let validUntil: string | undefined = undefined
        if (this.validForm.value.validUntil) {
            validUntil = moment(this.validForm.value.validUntil).format('YYYY-MM-DDTHH:mm:ssZ');
        }
        let access: CollectionAccessGrant = {
            users: this.selectedUsers.map(u => u.id),
            permission: this.permissionForm.value.permission,
            validFrom, validUntil
        }
        this.collectionService.addUserAccessToCollection(this.collection.uuid, access).subscribe({
            next: collection => {
                this.snackbarService.showMessage({
                    success: true,
                    message: 'collection.share.access.success'
                });
                this.collection = collection;
                this.collectionChange.emit(collection);
                this.back.emit();
            },
            error: (e) => {
                console.error(e);
                this.error = 'Error sharing collection';
            }
        });
    }

    ngOnDestroy() {
        this.searchSubscription?.unsubscribe();
    }
}
